var chunkMapping = {
	"apps_instance-management_src_Constants_NavSections_constants_tsx": [
		42609
	]
};
var idToExternalAndNameMapping = {
	"42609": [
		"default",
		"./State",
		1473
	]
};
var idToRemoteMap = {
	"42609": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}